module.exports = __webpack_public_path__ + "img/authentication_lost.9baa4112.png";